import { render, staticRenderFns } from "./workList.vue?vue&type=template&id=5dcc8648&scoped=true"
import script from "./workList.vue?vue&type=script&lang=js"
export * from "./workList.vue?vue&type=script&lang=js"
import style0 from "./workList.vue?vue&type=style&index=0&id=5dcc8648&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcc8648",
  null
  
)

export default component.exports